const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const LostCargoQuery: any = {
    GetLostCargoCompanies: Backofficebff + '/v1/cargo/companylist',
    GetInvoicePDF: Backofficebff + '/v1/billing/get-earchive-file',
};
